<template>
  <v-container fluid class="fill-height">
    <!-- DESKTOP -->
    <div class="d-none d-lg-block" style="width: 100%;">
      <v-card class="ma-16 pa-16" elevation="0">
        <v-row class="mt-n8">
          <v-col cols="12" md="6">
            <GoogleMap
              :api-key="getAPIKEY"
              style="width: 100%; height: 500px"
              :center="center"
              :zoom="15"
            >
              <Marker :options="{ position: center }" />
            </GoogleMap>

            <v-col cols="12" class="text-justify">
              <span class="text-body-1 text-uppercase text-justify">
                EDIRIO CONSTRUÇÕES, SA
              </span>
              <span class="text-body-1">
                <br />Lugar da Portela Alta – EN 105
                <br />Rua Dr. Francisco Sá Carneiro, 22
                <br />4825-087 Água Longa, Portugal
              </span>
            </v-col>
          </v-col>

          <v-col cols="12" md="6">
            <v-card>
              <v-toolbar color="primary">
                <v-toolbar-title>
                  <span class="text-h4 text-uppercase">
                    {{ $t('contactos.title') }}
                  </span>
                </v-toolbar-title>
              </v-toolbar>

              <v-card-text class="mx-12 px-12">
                <v-form :disabled="loading">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        variant="outlined"
                        v-model="contacts.name"
                        prepend-inner-icon="mdi-account-details"
                        label="Nome *"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        variant="outlined"
                        v-model="contacts.email"
                        prepend-inner-icon="mdi-at"
                        label="Email *"
                        type="email"
                        autocomplete="email"
                        :rules="[rules.required, rules.email]"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        variant="outlined"
                        v-model="contacts.subject"
                        prepend-inner-icon="mdi-text-short"
                        label="Subject *"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-textarea
                        variant="outlined"
                        v-model="contacts.message"
                        prepend-inner-icon="mdi-text-long"
                        label="Message"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12">
                      <!-- reCAPTCHA (desktop) -->
                      <div ref="recaptchaElDesktop" class="my-4"></div>

                      <v-btn
                        :disabled="disableButton || !recaptchaVerified || !canSend"
                        @click="contact"
                        depressed
                        color="primary"
                        class="font-weight-bold"
                      >
                        {{ $t('contactos.enviar') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-text class="text-body-1">
                Tel: +351 22 968 84 11<br /> Email: geral@edirio.pt
              </v-card-text>

              <v-card-text>
                <v-row>
                  <v-col cols="6" class="text-start">
                    <span
                      style="cursor:pointer; text-decoration: underline;"
                      @click="goTo()"
                      >{{ $t('contactos.normative') }}<br />{{ $t('contactos.complaints') }}</span
                    >
                  </v-col>
                  <v-col cols="6" class="text-end">
                    <br />
                    <span
                      style="cursor:pointer; text-decoration: underline;"
                      @click="openPolicy()"
                      >{{ $t('cookies.cookies_policy') }}</span
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <!-- MOBILE -->
    <div class="d-md-none">
      <v-card class="ma-0 pa-0" elevation="0">
        <v-row class="mt-8">
          <v-col cols="12" md="6">
            <v-card>
              <v-toolbar color="primary">
                <v-toolbar-title>
                  <span class="text-h4 text-uppercase">
                    {{ $t('contactos.title') }}
                  </span>
                </v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <v-form :disabled="loading">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        variant="outlined"
                        v-model="contacts.name"
                        prepend-inner-icon="mdi-account-details"
                        label="Nome *"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        variant="outlined"
                        v-model="contacts.email"
                        prepend-inner-icon="mdi-at"
                        label="Email *"
                        type="email"
                        autocomplete="email"
                        :rules="[rules.required, rules.email]"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        variant="outlined"
                        v-model="contacts.subject"
                        prepend-inner-icon="mdi-text-short"
                        label="Subject *"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-textarea
                        variant="outlined"
                        v-model="contacts.message"
                        prepend-inner-icon="mdi-text-long"
                        label="Message"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12">
                      <!-- reCAPTCHA (mobile) -->
                      <div ref="recaptchaElMobile" class="my-4"></div>

                      <v-btn
                        :disabled="disableButton || !recaptchaVerified || !canSend"
                        @click="contact"
                        depressed
                        color="primary"
                        class="font-weight-bold"
                      >
                        {{ $t('contactos.enviar') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-text class="text-body-1">
                Tel: +351 22 968 84 11<br /> Email: geral@edirio.pt
              </v-card-text>

              <v-card-text>
                <v-row>
                  <v-col cols="6" class="text-start">
                    <span
                      style="cursor:pointer; text-decoration: underline;"
                      @click="goTo()"
                      >{{ $t('contactos.normative') }}<br />{{ $t('contactos.complaints') }}</span
                    >
                  </v-col>
                  <v-col cols="6" class="text-end">
                    <br />
                    <span
                      style="cursor:pointer; text-decoration: underline;"
                      @click="openPolicy()"
                      >{{ $t('cookies.cookies_policy') }}</span
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <GoogleMap
              :api-key="getAPIKEY"
              style="width: 100%; height: 500px"
              :center="center"
              :zoom="15"
            >
              <Marker :options="{ position: center }" />
            </GoogleMap>

            <v-col cols="12" class="text-justify">
              <span class="text-body-1 text-uppercase text-justify">
                EDIRIO CONSTRUÇÕES, SA
              </span>
              <span class="text-body-1">
                <br />Lugar da Portela Alta – EN 105
                <br />Rua Dr. Francisco Sá Carneiro, 22
                <br />4825-087 Água Longa, Portugal
              </span>
            </v-col>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <ErrorSnackbar
      v-model="error.show"
      :message="error.msg"
      style="z-index: 9999 !important;"
    />
  </v-container>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { GoogleMap, Marker } from 'vue3-google-map'
import ErrorSnackbar from '@/components/ui/ErrorSnackbar'
import EmailService from '@/services/EmailService'
import { computed } from 'vue'

export default {
  name: 'ContactsView',
  components: { GoogleMap, Marker, ErrorSnackbar },
  setup() {
    const rules = {
      required: v => !!(v && v.toString().trim()) || 'Obrigatório',
      email: v =>
        !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Email inválido',
    }

    const getAPIKEY = computed(() => process.env.VUE_APP_GOOGLE_KEY)
    const route = useRoute()
    const router = useRouter()
    const i18n = useI18n()

    // reactive
    const loading = ref(false)
    const disableButton = ref(false)
    const error = ref({ show: false, msg: '' })
    const valid = ref(true)
    const contacts = ref({ name: null, email: null, subject: null, message: null })

    const center = ref({ lat: 41.24967775204666, lng: -8.5104816418242 })
    const markers = ref([{ position: { lat: 41.24967775204666, lng: -8.5104816418242 } }])

    // ENV
    const SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY
    const SEND_URL = process.env.VUE_APP_SEND_EMAIL // ex.: http://localhost:8000/api/contact  // <<<
    const canSend = ref(!!SEND_URL) // se há URL, pode enviar  // <<<

    // reCAPTCHA
    const recaptchaElDesktop = ref(null)
    const recaptchaElMobile = ref(null)
    const recaptchaIdDesktop = ref(null) // <<< guardar ambos
    const recaptchaIdMobile = ref(null)  // <<<
    const recaptchaVerified = ref(false)
    const recaptchaToken = ref('')
    const startedAt = ref(Math.floor(Date.now() / 1000)) // <<< tempo mínimo
    const hp = ref('') // <<< honeypot

    // dentro do setup()
    

    // carrega script do reCAPTCHA v2 (explicit)
    const loadRecaptchaScript = () =>
      new Promise((resolve, reject) => {
        if (window.grecaptcha && window.grecaptcha.render) return resolve()
        const s = document.createElement('script')
        s.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=pt-PT'
        s.async = true
        s.defer = true
        s.onload = resolve
        s.onerror = reject
        document.head.appendChild(s)
      })

    const onCaptchaSuccess = (token) => {
      recaptchaToken.value = token
      recaptchaVerified.value = true
    }

    const onCaptchaExpired = () => {
      recaptchaVerified.value = false
      recaptchaToken.value = ''
      try {
        if (recaptchaIdDesktop.value !== null) window.grecaptcha.reset(recaptchaIdDesktop.value)
        if (recaptchaIdMobile.value  !== null) window.grecaptcha.reset(recaptchaIdMobile.value)
      } catch (e) { void e } // evita no-empty sem usar console
    }

    const renderRecaptcha = () => {
      if (!SITE_KEY) {
        console.error('reCAPTCHA: Site Key em falta (VUE_APP_RECAPTCHA_SITE_KEY).')
        return
      }
      if (recaptchaElDesktop.value && recaptchaIdDesktop.value === null) {
        recaptchaIdDesktop.value = window.grecaptcha.render(recaptchaElDesktop.value, {
          sitekey: SITE_KEY,
          callback: onCaptchaSuccess,
          'expired-callback': onCaptchaExpired,
          theme: 'light',
          size: 'normal',
        })
      }
      if (recaptchaElMobile.value && recaptchaIdMobile.value === null) {
        recaptchaIdMobile.value = window.grecaptcha.render(recaptchaElMobile.value, {
          sitekey: SITE_KEY,
          callback: onCaptchaSuccess,
          'expired-callback': onCaptchaExpired,
        })
      }
    }

    const openPolicy = () => window.open('/' + i18n.locale.value + '/privacy', '_blank')
    const goTo = () => window.open('https://incognito.conduril.pt/pt', '_blank')

    const contact = async () => {
      // validações simples
      const okName = !!contacts.value.name?.trim()
      const okEmail = !!contacts.value.email?.includes('@')
      const okSubj = !!contacts.value.subject?.trim()
      const okMsg  = !!contacts.value.message?.trim()
      if (!(okName && okEmail && okSubj && okMsg)) {
        error.value.msg = 'Por favor, preencha os campos obrigatórios.'
        error.value.show = true
        return
      }

      // token a partir dos widgets (mais fiável que confiar no callback)
      let token = ''
      try {
        if (recaptchaIdDesktop.value !== null) token = window.grecaptcha.getResponse(recaptchaIdDesktop.value) || ''
        if (!token && recaptchaIdMobile.value !== null) token = window.grecaptcha.getResponse(recaptchaIdMobile.value) || ''
      } catch (e) { void e }
      if (!token) {
        error.value.msg = 'Por favor, confirme o reCAPTCHA.'
        error.value.show = true
        return
      }

      if (!canSend.value) {
        error.value.msg = 'Envio desativado (VUE_APP_SEND_EMAIL não definido).'
        error.value.show = true
        return
      }

      disableButton.value = true
      try {
        // ⚠️ backend espera 'g-recaptcha-response'
        const payload = {
          name: contacts.value.name,
          email: contacts.value.email,
          subject: contacts.value.subject,
          message: contacts.value.message,
          'g-recaptcha-response': token, // <<<
          website_hp: hp.value,          // <<<
          started_at: startedAt.value,   // <<<
        }

        // EmailService deve POSTar em JSON para SEND_URL
        const result = await EmailService.sendContactEmail(payload, SEND_URL) // <<< aceita URL
        console.log(`Email enviado com sucesso via ${result?.provider || 'backend'}`, result)
        router.push('/' + i18n.locale.value + '/sucesso')
      } catch (err) {
        console.error('Erro ao enviar email:', err)
        error.value.show = true
        error.value.msg = err?.message || 'Erro ao enviar mensagem. Tente novamente.'
        try {
          if (recaptchaIdDesktop.value !== null) window.grecaptcha.reset(recaptchaIdDesktop.value)
          if (recaptchaIdMobile.value  !== null) window.grecaptcha.reset(recaptchaIdMobile.value)
        } catch (e) {console.log(e)}
        recaptchaVerified.value = false
        recaptchaToken.value = ''
      } finally {
        disableButton.value = false
      }
    }

    onMounted(async () => {
      if (route.params.language != undefined) {
        i18n.locale.value = route.params.language
      }
      loading.value = false

      // analytics só se cookies permitidos
      const { $cookies, $gtag } = getCurrentInstance().appContext.config.globalProperties
      const cookie = $cookies.get('edirio_cookie')
      if (cookie && cookie.statistics !== false) {
        $gtag.event('call_tag', {
          event_category: 'AgendarChamada',
          event_label: 'AgendarChamada',
          value: 'call_tag',
        })
      }

      // reCAPTCHA
      try {
        await loadRecaptchaScript()
        renderRecaptcha()
      } catch (e) {
        console.error('Falha ao carregar/renderizar reCAPTCHA:', e)
        error.value.msg = 'Não foi possível carregar o reCAPTCHA.'
        error.value.show = true
      }
    })

    return {
      loading,
      disableButton,
      error,
      valid,
      contacts,
      center,
      rules,
      markers,
      openPolicy,
      goTo,
      contact,
      // recaptcha
      recaptchaElDesktop,
      recaptchaElMobile,
      recaptchaVerified,
      canSend,
      getAPIKEY
    }
  },
}
</script>
